/**
 * Global object to store the current price formatting details.
 * Initialize with defaults (you can adjust these).
 */
let currentPriceFormat = {
    currencySymbol: 'Kč', // Default currency
    decimalSeparator: ',', // Default decimal separator
    thousandSeparator: '.', // Default thousand separator
    decimalPlaces: 2       // Default number of decimal places
};

/**
 * Extracts only the currency symbol (non-numeric part at the end).
 * (Your original function - slightly refined for clarity)
 */
function extractCurrencySymbol(priceString) {
    if (!priceString || typeof priceString !== 'string') {
        return ""; // Return empty string for invalid input
    }
    // Use a regular expression to find non-numeric, non-dot, non-comma chars at the end
    // allowing for spaces before the currency.
    const match = priceString.trim().match(/([^0-9.,\s]+)$/);
    return match && match[1] ? match[1] : ""; // Return symbol or empty string
}

/**
 * Extracts formatting details (currency, separators, decimal places) from a price string.
 * Updates the global currentPriceFormat object.
 */
function extractAndUpdateFormatting(priceString) {
    if (!priceString || typeof priceString !== 'string') {
        console.warn("extractAndUpdateFormatting: Invalid input string.");
        return; // Do not update format if input is invalid
    }

    const symbol = extractCurrencySymbol(priceString);
    // Get the number part by removing the currency symbol and trimming whitespace
    const numberPart = priceString.replace(symbol, '').trim();

    let decSeparator = null;
    let thouSeparator = null;
    let decPlaces = 0;

    // Find the last non-digit character in the number part - potential decimal separator
    const lastNonDigitIndex = numberPart.search(/[^0-9](?!.*[^0-9])/);

    if (lastNonDigitIndex > 0) { // Found potential decimal separator
        decSeparator = numberPart[lastNonDigitIndex];
        decPlaces = numberPart.length - lastNonDigitIndex - 1;
        const integerPart = numberPart.substring(0, lastNonDigitIndex);
        // Find the first non-digit in the integer part - potential thousand separator
        const firstNonDigitMatch = integerPart.match(/[^0-9]/);
        if (firstNonDigitMatch) {
            thouSeparator = firstNonDigitMatch[0];
        }
    } else { // No decimal separator found, check for thousand separators in the whole string
        decPlaces = 0;
        const firstNonDigitMatch = numberPart.match(/[^0-9]/);
        if (firstNonDigitMatch) {
            thouSeparator = firstNonDigitMatch[0];
        }
    }

    // Basic validation: separators shouldn't be the same unless one wasn't found
    if (thouSeparator && decSeparator && thouSeparator === decSeparator) {
        console.warn("Ambiguous number format detected:", priceString, "- Using previous/default separators.");
        // Keep previous/default separators, only update currency and maybe decimal places
         currentPriceFormat.currencySymbol = symbol || currentPriceFormat.currencySymbol;
         // We could potentially still trust decimal places if found:
         // currentPriceFormat.decimalPlaces = decPlaces;
         return; // Avoid setting ambiguous separators
    }

    // Update global format object
    currentPriceFormat.currencySymbol = symbol || currentPriceFormat.currencySymbol; // Use extracted or keep old
    currentPriceFormat.decimalSeparator = decSeparator !== null ? decSeparator : currentPriceFormat.decimalSeparator; // Use extracted or keep old
    currentPriceFormat.thousandSeparator = thouSeparator !== null ? thouSeparator : currentPriceFormat.thousandSeparator; // Use extracted or keep old
    currentPriceFormat.decimalPlaces = decPlaces; // Always update decimal places based on detection
     // Handle cases where separators might be detected as empty string if none exist
     if (currentPriceFormat.decimalSeparator === '') currentPriceFormat.decimalPlaces = 0;


    // console.log("Updated format:", currentPriceFormat); // For debugging
}

/**
 * Formats a number according to the globally stored format.
 */
function formatNumberWithCurrentStyle(number) {
    try {
        number = parseFloat(number);
        if (isNaN(number)) {
            return ""; // Return empty string for invalid number
        }

        // Use toFixed for correct rounding and decimal places
        const fixedNumber = number.toFixed(currentPriceFormat.decimalPlaces);
        let [integerPart, fractionalPart] = fixedNumber.split('.');

        // Add thousand separators if one is defined
        if (currentPriceFormat.thousandSeparator) {
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, currentPriceFormat.thousandSeparator);
        }

        // Combine parts using the correct decimal separator
        if (currentPriceFormat.decimalPlaces > 0 && currentPriceFormat.decimalSeparator) {
             // Ensure fractionalPart exists even if toFixed result was integer (e.g. 10.toFixed(2) -> "10.00")
             fractionalPart = fractionalPart || '0'.repeat(currentPriceFormat.decimalPlaces);
             return integerPart + currentPriceFormat.decimalSeparator + fractionalPart;
        } else {
            return integerPart; // No fractional part or separator needed/defined
        }
    } catch (e) {
        console.error("Error formatting number:", e);
        return number.toString(); // Fallback to basic string conversion
    }
}
  
  "use strict";
  if (window.kingslayer.customBackground) {
      document.body.classList.add("custom-bg");
  }
  const dfsds = document.querySelectorAll(".js-header-drop-container");
  const dropBoxes = document.querySelectorAll(".js-header-drop-box");
  dfsds.forEach((container) => {
      let a = container.querySelector("a");
      let drop = container.querySelector(".js-header-drop-box");
      a?.addEventListener("click", () => {
          if (drop?.classList.contains("visible")) {
              drop?.classList.remove("visible");
              return;
          }
          dfsds.forEach((containe) => {
              let b = containe.querySelector(".js-header-drop-box");
              b?.classList.remove("visible");
          });
          drop?.classList.add("visible");
      });
  });
  document.body.addEventListener("click", (event) => {
      const target = event.target;
      if (!dropBoxes || !dropBoxes.length)
          return;
      const isClickInsideDropBox = Array.from(dropBoxes).some((dropBox) => dropBox.contains(target)) ||
          Array.from(dfsds).some((dropBox) => dropBox.contains(target));
      if (!isClickInsideDropBox) {
          dropBoxes.forEach((dropBox) => {
              dropBox.classList.remove("visible");
          });
      }
  });
  // Currency

  var currentCurrency = "";

function updateCurrenciesDisplay(originalPrice) {
    // Step 1: If originalPrice is provided, parse it to update the global format
    if (originalPrice) {
        extractAndUpdateFormatting(originalPrice);
    }

    // Step 2: Select all price elements
    const currencyDisplays = Array.from(document.querySelectorAll(".js-price"));

    // Step 3: Iterate and update each element
    currencyDisplays.forEach((elem) => {
        const dataPrice = elem.getAttribute("data-price");
        if (dataPrice == null) {
            // Skip elements without data-price
            return;
        }

        // Assume data-price is in the smallest unit (e.g., cents, haléře)
        let amount = parseFloat(dataPrice) / 100;

        // Format the number using the current style
        const formattedAmount = formatNumberWithCurrentStyle(amount);

        // Update the element's text, adding a space before the currency symbol
        // Ensure currencySymbol isn't null/empty before adding space
        elem.innerText = formattedAmount + (currentPriceFormat.currencySymbol ? ` ${currentPriceFormat.currencySymbol}` : '');
    });
}


  // Timer
  if (window.kingslayer.timerEnabled) {
      function startCountdown(futureTimestamp) {
          const pElements = document.querySelectorAll(".timer");
          function updateCountdown() {
              const now = Math.floor(Date.now() / 1000);
              const timeLeft = futureTimestamp - now;
              if (timeLeft <= 0) {
                  pElements.forEach((p) => {
                      p.innerText = "REFRESH | F5";
                  });
                  clearInterval(timerInterval);
              }
              else {
                  // HOURS
                  const hours = Math.floor(timeLeft / 3600);
                  const minutes = Math.floor((timeLeft % 3600) / 60);
                  const seconds = timeLeft % 60;
                  const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
                  // UPDATING
                  pElements.forEach((p) => {
                      p.innerText = formattedTime;
                  });
              }
          }
          // Initial call to set the countdown immediately
          updateCountdown();
          // Update every second
          const timerInterval = setInterval(updateCountdown, 1000);
      }
      // Example usage: Replace 'YOUR_TIMESTAMP_HERE' with the actual future timestamp in milliseconds
      const futureTimestamp = window.kingslayer.timerTimestamp;
      startCountdown(futureTimestamp);
  }

  // Lazy Loading
  // Select all images with a specific class (e.g., 'lazy') to avoid selecting unnecessary images
  const lazyImages = document.querySelectorAll("img.lazy");
  // Define options for Intersection Observer
  const lazyImagesOptions = {
      root: null, // Relative to the viewport
      rootMargin: "0px", // No margin
      threshold: 0.1, // Trigger when 10% of the image is in view
  };
  // Create a new Intersection Observer instance
  const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
          if (entry.isIntersecting) {
              const image = entry.target;
              const newURL = image.getAttribute("data-srcset");
              if (newURL) {
                  image.setAttribute("srcset", newURL);
                  observer.unobserve(image); // Stop observing the image
              }
          }
      });
  }, lazyImagesOptions);
  // Observe each lazy image
  lazyImages.forEach((image) => {
      observer.observe(image);
  });

  window.kingslayer.updateCurrenciesDisplay = updateCurrenciesDisplay;
  